module.exports = __webpack_public_path__ + "static/media/croissants.03a5fcdc.mp4";